import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { Stack, Typography } from "@mui/material";
import { useIsMobile } from "Hooks/useIsMobile";
import type { PropsWithChildren } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.MobileApp.InstallBanner;

/**
 * Shared inner layout of the install banner — icon, texts, and a slot for
 * the store badge(s) passed as children.
 */
export const MobileAppInstallBannerContent = ({
  children,
}: PropsWithChildren) => {
  const { t } = useResource();
  const isMobile = useIsMobile();

  return (
    <Stack direction="row" alignItems="center" gap={2} p={3} flexWrap="wrap">
      {!isMobile && (
        <PhoneIphoneIcon sx={{ fontSize: "3rem", color: "common.white" }} />
      )}
      <Stack gap={0.5} flex={1} minWidth={150}>
        <Typography variant="subtitle1" fontWeight={700} color="common.white">
          {t(RESOURCES.Title)}
        </Typography>
        <Typography variant="body2" color="grey.300">
          {t(RESOURCES.Description)}
        </Typography>
      </Stack>
      <Stack direction="row" gap={2.5} flexWrap="wrap">
        {children}
      </Stack>
    </Stack>
  );
};
